const sideNavStyles = {
  mailzzyLogoBox: {
    display: "flex",
    pt: "4px",
    cursor: "pointer",
    width: "100%",
    transition: "padding 0.3s ease-in-out",
  },
  mailzzyLogoBoxCollapsed: {
    display: "flex",
    pt: "4px",
    // justifyContent: "center",
    // alignItems: "center",
    cursor: "pointer",
    width: "100%",
    transition: "padding 0.3s ease-in-out",
  },
  collpaseIconButton: {
    mt: 2,
    position: "absolute",
    padding: "10px",
    transition: "left 0.3s ease-in-out",
    transform: "translate(-50%, -50%)",
    zIndex: 1300,
    borderRadius: "50%",
  },
} as const;

export default sideNavStyles;
